import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./providers/AuthProvider";
import AppInitializer from "./AppInitializer";
import RoutesApp from "./routing/routes";
import AppTheme from "../shared/theme/AppTheme";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <AuthProvider>
      <AppInitializer>
        <AppTheme>
          <Toaster
            reverseOrder
            toastOptions={{
              position: "bottom-left",
              style: { maxWidth: "100vw" },
              duration: 5000,
            }}
          />

          <BrowserRouter>
            <RoutesApp />
          </BrowserRouter>
        </AppTheme>
      </AppInitializer>
    </AuthProvider>
  );
}

export default App;